import React, { useState, useEffect } from 'react';
import './ConceptMatchingGame.styles.sass';

function shuffleArray(array) {
  return array.sort(() => Math.random() - 0.5);
}

function ConceptMatchingGame({ conceptsData, meaningsData }) {
  const [shuffledConcepts, setShuffledConcepts] = useState([]);
  const [shuffledMeanings, setShuffledMeanings] = useState([]);
  const [matchedConcepts, setMatchedConcepts] = useState({});
  const [dragging, setDragging] = useState(null);
  const [showCongrats, setShowCongrats] = useState(false);
  const [shakeConcept, setShakeConcept] = useState(null);

  useEffect(() => {
    // Shuffle concepts and meanings when the component mounts
    setShuffledConcepts(shuffleArray([...conceptsData]));
    setShuffledMeanings(shuffleArray([...meaningsData]));
  }, []);

  const handleDragStart = conceptId => {
    setDragging(conceptId);
  };

  const handleDrop = meaningId => {
    if (dragging) {
      // Find the current position of the dragged concept and the concept aligned with the meaning
      const conceptIndex = shuffledConcepts.findIndex(concept => concept.id === dragging);
      const meaningIndex = shuffledMeanings.findIndex(meaning => meaning.id === meaningId);

      if (dragging === meaningId) {
        // If it's the correct concept, swap positions
        const newShuffledConcepts = [...shuffledConcepts];
        const temp = newShuffledConcepts[meaningIndex];
        newShuffledConcepts[meaningIndex] = newShuffledConcepts[conceptIndex];
        newShuffledConcepts[conceptIndex] = temp;

        setShuffledConcepts(newShuffledConcepts);

        // Mark the concept as correctly connected
        setMatchedConcepts(prev => ({
          ...prev,
          [dragging]: true
        }));
      } else {
        // If incorrect, add the error class
        setShakeConcept(dragging);
        setTimeout(() => setShakeConcept(null), 500); // Remove the error class after the animation
      }

      setDragging(null);
      document.querySelectorAll('.droppable').forEach(el => el.classList.remove('highlight-dropzone'));
    }
  };

  const handleDragOver = e => {
    e.preventDefault();
    e.currentTarget.classList.add('highlight-dropzone');
  };

  const handleDragLeave = e => {
    e.currentTarget.classList.remove('highlight-dropzone');
  };

  useEffect(() => {
    if (Object.keys(matchedConcepts).length === conceptsData.length) {
      setShowCongrats(true);
    }
  }, [matchedConcepts]);

  return (
    <div className="game-container">
      <div className="instructions mb-1 rounded-xl border border-solid border-neutral-100 bg-white px-4 py-2.5 font-semibold text-primary-dark shadow-card">Arraste os conceitos para conectá-los com seus respectivos significados</div>
      <div className="game-content">
        {shuffledMeanings.map((meaning, index) => (
          <div
            key={meaning.id}
            className={matchedConcepts[shuffledConcepts[index].id] ? 'concept-meaning-row concept-meaning-row--matching' : 'concept-meaning-row'}
          >
            <span className="concept-meaning-number">{index + 1}</span>
            <div className="concept-wrapper">
              <div
                className={`draggable ${shakeConcept === shuffledConcepts[index].id ? 'shake flash-red' : ''} ${matchedConcepts[shuffledConcepts[index].id] ? 'draggable--matching' : ''}`}
                draggable={!matchedConcepts[shuffledConcepts[index].id]}
                onDragStart={() => handleDragStart(shuffledConcepts[index].id)}
              >
                <p>{shuffledConcepts[index].name}</p>
              </div>
            </div>
            <div
              className={`droppable ${matchedConcepts[shuffledConcepts[index].id] ? 'droppable--matching' : ''}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={() => handleDrop(meaning.id)}
            >
              {meaning.meaning}
            </div>
          </div>
        ))}
      </div>
      {showCongrats && <div className="congrats-message">Parabéns! Você conectou todos os conceitos corretamente!</div>}
    </div>
  );
}

export default ConceptMatchingGame;
